export default "__VITE_ASSET__2223f378__"